export function isMimeType(expectedMimeType, actualFileType) {
    return actualFileType.match("^" + expectedMimeType + "$") !== null;
}
